import { styled, Switch } from '@mui/material';
import { omit } from 'lodash';
import { forwardRef, useState } from 'react';

const CustomSwitch = styled(Switch)(({ theme, $isFocused }) => {
    return {
        borderRadius: '100px',
        width: '52px',
        height: '28px',
        padding: 0,
        '& > .MuiSwitch-switchBase': {
            left: '4px',
            margin: theme.spacing(1, 0),
            width: '20px',
            height: '20px',
            padding: 0,
            '&.Mui-checked': {
                color: theme.palette.ensightful.shades[0],
                transform: 'translateX(24px)',
                '&.Mui-disabled + .MuiSwitch-track': {
                    background: theme.palette.ensightful.primary[100],
                },
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                background: theme.palette.ensightful.neutral[400],
            },
        },
        '& > .MuiSwitch-track': {
            background: theme.palette.ensightful.neutral[600],
            opacity: '1 !important',
        },
        ...($isFocused && {
            outline: `${theme.palette.ensightful.secondary[400]} solid 3px`,
            outlineOffset: '4px',
        }),
        '&:hover': {
            '& > .MuiSwitch-switchBase': {
                '&:not(.Mui-disabled)': {
                    color: theme.palette.ensightful.neutral[50],
                    '&.Mui-checked': {
                        color: theme.palette.ensightful.primary[50],
                    },
                },
            },
        },
        '&:active': {
            '& > .MuiSwitch-switchBase': {
                '&:not(.Mui-disabled)': {
                    color: theme.palette.ensightful.neutral[100],
                    '&.Mui-checked': {
                        color: theme.palette.ensightful.primary[100],
                    },
                },
            },
        },
    };
});

export default forwardRef(({ ...rest }, ref) => {
    const [isFocused, setIsFocused] = useState(false);

    return (
        <CustomSwitch
            ref={ref}
            aria-disabled={undefined}
            inputProps={{
                'aria-label': rest['aria-label'],
                'aria-labelledby': rest['aria-labelledby'],
                ...rest.inputProps,
            }}
            {...omit(rest, ['aria-labelledby'])}
            $isFocused={isFocused}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
        />
    );
});
